import { performMiddagstipsBffRequest } from "@modules/recipes/api/MiddagstipsBff"

export interface FeedbackSubmission {
    appVersion?: string
    comment?: string
    osVersion?: string
    page: string
    platform?: "iOS" | "Android"
    question: string
    rating: "0" | "1"
    rhash?: string
}

export const normalizeFeedbackPlatform = (os?: string): FeedbackSubmission["platform"] => {
    const normalizedOs = os?.toLowerCase()

    if (normalizedOs === "ios") return "iOS"
    if (normalizedOs === "android") return "Android"

    return undefined
}

export const submitFeedback = async ({
    appVersion,
    comment,
    osVersion,
    page,
    platform,
    question,
    rating,
    rhash,
}: FeedbackSubmission) => {
    await performMiddagstipsBffRequest({
        method: "POST",
        path: "/api/feedback",
        body: {
            chain: "Meny",
            vurdering: rating,
            kommentar: comment,
            side: page,
            sporsmaal: question,
            appversjon: appVersion,
            plattform: platform,
            osVersjon: osVersion,
            rhash,
        },
    })
}
